/* eslint-disable react/jsx-pascal-case */
import React from "react";
import moment from "moment";
import { Palette } from "../AppConfig";
import Button from "@material-ui/core/Button";
import { DatePicker } from "@material-ui/pickers";
import BSL_ControlContainer from "./BSL_ControlContainer";
import { makeStyles, withStyles } from "@material-ui/core/styles";

const StyledButton = withStyles((theme) => ({
    root: {
        fontSize: "11pt",
        fontFamily: theme.typography.fontFamily,
        fontWeight: "200",
        padding: "6px 20px",
        minWidth: "35px",
        background: "#192E61",
        color: "white",
        boxShadow: "none",
        width: "fit-content",
        maxwidth: "200px",
        "&:hover": {
            color: "white !important",
            background: "#0F1F41 !important",
        },
        "&:hover label": {
            color: "white",
        },
    },
    disabled: {
        background: "#FFFFFF00 !important",
        color: Palette.Control.Grey + " !important",
    },
}))(Button);

const useStyles = makeStyles({
    tight: {
        fontSize: "10pt",
        padding: "2px 10px",
    },
});

function disableWeekends(date) {
    return date.getDay() === 0 || date.getDay() === 6;
}

export default function BSL_DatePicker(props) {
    const classes = useStyles();

    // Default to current date
    var minimumDate = moment(moment().toDate(), "DD-MM-YYYY").add(props?.disableForwardDays ?? 0, "days");

    return (
        <BSL_ControlContainer {...props}>
            <DatePicker
                disabled={props?.disabled}
                value={props.value === undefined ? minimumDate : props.value}
                onChange={props.onChange}
                minDate={minimumDate}
                variant="inline"
                disableToolbar
                style={{
                    width: "100%",
                }}
                shouldDisableDate={props?.enableWeekends ? false : disableWeekends}
            />
        </BSL_ControlContainer>
    );
}
